import React, { useState, useEffect } from 'react';
import useRendicontazioneAdmin from '../../hooks/useRendicontazioneAdmin';
import useMediaQuery from '../../hooks/useMediaQuery';
import CustomTable from '../../components/CustomTable/CustomTable';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import RendicontazioneDettaglioModal from '../../components/RendicontazioneDettaglioModal/RendicontazioneDettaglioModal';
import useArchivioRendicontazioniSuperpartnerConfigTable from '../../configTable/useArchivioRendicontazioniSuperpartnerConfigTable';

const ArchivioRendicontazioniSuperpartnerPage = () => {
    const isWideScreen = useMediaQuery('(min-width: 1200px)');
    const { loadingStateAdmin, findLiquidateSuperpartner, getDettaglioSuperpartner } = useRendicontazioneAdmin();

    const [rendicontazioni, setRendicontazioni] = useState([]);
    const archivioConfigTable = useArchivioRendicontazioniSuperpartnerConfigTable();

    const [showDettaglioModal, setShowDettaglioModal] = useState(false);
    const [selectedRendicontazione, setSelectedRendicontazione] = useState(null);
    const [dettaglioData, setDettaglioData] = useState([]);

    const openDettaglioModal = async (item) => {
        setSelectedRendicontazione(item);
        setShowDettaglioModal(true);
        const dettagli = await getDettaglioSuperpartner(item.id_superpartner_rendicontazione);
        setDettaglioData(dettagli);
    };

    useEffect(() => {
        const fetchArchivio = async () => {
            const data = await findLiquidateSuperpartner({});
            setRendicontazioni(data);
        };
        fetchArchivio();
    }, []);

    const actions = [
      { icon: 'bi-eye-fill text-info', label: 'Dettaglio', onClick: openDettaglioModal }
    ];

    return (
        <>
            <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`}>
                <div className="container">
                    <div className="d-flex justify-content-between custom-card-header">
                        <div className="d-flex gap-3 custom-card-title my-2">
                            <div className="custom-icon-container"><i className="bi custom-icon bi-archive-fill fs-2"></i></div>
                            <div className="align-self-center"><span className="fs-4 d-block"><i><b>Archivio Rendicontazioni Superpartner</b></i></span></div>
                        </div>
                    </div>

                    <div className="mt-4">
                        {loadingStateAdmin.isFinding ? (
                            <LoadingTable loadingCol={5} />
                        ) : rendicontazioni.length > 0 ? (
                            <CustomTable data={rendicontazioni} columns={archivioConfigTable} actions={actions} actionsLabel="Dettaglio" />
                        ) : (
                            <div className='mt-5 pt-5 text-center'><p>Nessuna rendicontazione trovata nell'archivio.</p></div>
                        )}
                    </div>
                </div>
            </div>

            {selectedRendicontazione && (
                <RendicontazioneDettaglioModal
                    show={showDettaglioModal}
                    onHide={() => setShowDettaglioModal(false)}
                    rendicontazione={selectedRendicontazione}
                    dettaglio={dettaglioData}
                />
            )}
        </>
    );
};

export default ArchivioRendicontazioniSuperpartnerPage;